@if (showSpinner) {
<app-loader> </app-loader>
}
<div class="main-teamManagment-wrapper">
  @if (isavailablefeature("isView")) {
  <div class="inner-section-teamManagment">
    <div class="team-managment-main-wrapper">
      <div class="team-managment-header">
        <div class="left-heading-conetnt">
          <h1>Team Management</h1>

        </div>
        <div class="right-create-user-button">
          @if (employeeTab === "current") {
          <div class="right-filter-section">
            <input type="text" placeholder="Search Employees" [(ngModel)]="searchTerm" (input)="filterUsers()" />
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                stroke="#555555" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          }
        </div>
      </div>
      <div class="tab-content">
        @if (activeTab === "user-list") {
        <div>
          @if (!isTeamView) {
          <div class="team-management-table-wrapper">
            <table class="team-management-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Position</th>
                  <th>Role</th>
                  <th class="fit-content-td">Shift Time</th>
                  @if (
                  isavailablefeature("isWFH") && employeeTab === "current"
                  ) {
                  <th class="fit-content-td">Allow WFH</th>
                  }
                  @if (
                  isavailablefeature("isDeleteUser") ||
                  isavailablefeature("isUpdateUser") ||
                  isavailablefeature("isMothySalary")
                  ) {
                  <th class="fit-content-td">Action</th>
                  }
                </tr>
              </thead>
              @if (employeeTab === "current") {
              <tbody>
                @for (
                departmentName of departmentNames;
                track departmentName
                ) {
                @for (
                user of filteredUsersList[departmentName];
                track user;
                let i = $index
                ) {
                <tr>
                  <td class="user-name-td" (click)="showUserDetails(user)">
                    <img src="{{ user.profile_image }}" alt="" />
                    <span class="text-elipse">{{ user.first_name }}
                      {{ user.last_name }}</span>
                  </td>
                  <td>
                    <p class="text-elipse">{{ user.email }}</p>
                  </td>
                  <td>
                    <p class="text-elipse">{{ user.description }}</p>
                  </td>

                  <td>
                    <p class="text-elipse">{{ user.department }}</p>
                  </td>
                  <td class="fit-content-td">
                    <!-- {{ convertTo12Hour(user.usershittime[0].start_time ?? user.shift_start_time) }} -->
                    {{
                    convertTo12Hour(
                    user.usershittime &&
                    user.usershittime.length > 0
                    ? user.usershittime[0].start_time
                    : user.shift_start_time
                    )
                    }}
                    to
                    <!-- {{ convertTo12Hour(user.usershittime[0].end_time ?? user.shift_end_time) }} -->
                    {{
                    convertTo12Hour(
                    user.usershittime &&
                    user.usershittime.length > 0
                    ? user.usershittime[0].end_time
                    : user.shift_end_time
                    )
                    }}
                  </td>
                  @if (isavailablefeature("isWFH")) {
                  <td class="fit-content-td text-center">
                    <label class="switch">
                      <input type="checkbox" #toggleRef [checked]="isWFHAllowed(user)" (change)="
                                      toggleClick(user, $event, toggleRef)
                                    " />
                      <span class="slider round"></span>
                    </label>
                  </td>
                  }
                  @if (
                  isavailablefeature("isDeleteUser") ||
                  isavailablefeature("isUpdateUser") ||
                  isavailablefeature("isMothySalary") ||
                  isavailablefeature("isReset") ||
                  isavailablefeature("isAction")
                  ) {
                  <td class="fit-content-td text-center toogle-button">
                    <div class="dropdown-action">
                      <button class="dropdown-toggle-button" (click)="
                                      toggleDropdown(user.id);
                                      $event.stopPropagation()
                                    ">
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                            stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                            stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                            stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </button>
                      <div class="dropdown-wrapper" [class.show]="
                                      openedDropdownUserId === user.id
                                    ">
                        <ul class="dropdown-content">
                          @if (
                          isavailablefeature("isMothySalary")
                          ) {
                          <li>
                            <a (click)="showDetails(user)">
                              <img src="../../assets/team-management/salary.svg" />
                              <span>View Payroll</span>
                            </a>
                          </li>
                          }
                          @if(isavailablefeature("isReset")){
                          <li>
                            <a (click)="confirmReset2FA(user)">
                              <i class="fa fa-refresh"></i>
                              <span>Reset 2FA</span>
                            </a>
                          </li>
                          }
                          @if(isavailablefeature("isAction")){
                          <li>
                            <a class="on-off">
                              <span>Enable 2FA</span>
                              <label class="switch">
                                <input type="checkbox" #toggleRef2FA_table [checked]="user.auth_verify == 1"
                                  (change)="onTwoFactorClick(user, $event, toggleRef2FA_table)" />
                                <span class="slider-red round"></span>
                              </label>
                            </a>
                          </li>
                          }


                          @if (isavailablefeature("isUpdateUser")) {
                          <li>
                            <a data-toggle="modal" data-target="#quickEditModal" (click)="setUserUUID(user.uuid)">
                              <img src="../../assets/team-management/edit-user.svg" />
                              <span>Edit</span>
                            </a>
                          </li>
                          }
                          <li>
                            @if (
                            isavailablefeature("isDeleteUser")
                            ) {
                            <a (click)="deleteModal(user)" data-toggle="modal" data-target="#deleteModal">
                              <img src="../../assets/team-management/delete-user.svg" />
                              <span>Delete</span>
                            </a>
                            }
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                  }
                </tr>
                }
                }
              </tbody>
              }
              @if (employeeTab === "ex") {
              <tbody>
                @for (department of departmentNames1; track department) {
                @if (
                oldUsersList[department] &&
                oldUsersList[department].length > 0
                ) {
                @for (
                user of filteredOldUsersList[department];
                track user;
                let i = $index
                ) {
                <tr>
                  <td class="user-name-td">
                    <img src="{{ user.profile_image }}" alt="" />
                    <span class="text-elipse">{{ user.first_name }}
                      {{ user.last_name }}</span>
                  </td>
                  <td>
                    <p class="text-elipse">{{ user.email }}</p>
                  </td>
                  <td>
                    <p class="text-elipse">
                      {{ user.description }}
                    </p>
                  </td>
                  <td>
                    <p class="text-elipse">{{ user.department }}</p>
                  </td>
                  <td class="fit-content-td">
                    <!-- {{ convertTo12Hour(user.usershittime[0].start_time ?? user.shift_start_time) }} -->
                    {{
                    convertTo12Hour(
                    user.usershittime &&
                    user.usershittime.length > 0
                    ? user.usershittime[0].start_time
                    : user.shift_start_time
                    )
                    }}
                    to
                    <!-- {{ convertTo12Hour(user.usershittime[0].end_time ?? user.shift_end_time) }} -->
                    {{
                    convertTo12Hour(
                    user.usershittime &&
                    user.usershittime.length > 0
                    ? user.usershittime[0].end_time
                    : user.shift_end_time
                    )
                    }}
                  </td>
                  <td class="fit-content-td text-center toogle-button">
                    <div class="dropdown-action">
                      <button class="dropdown-toggle-button" (click)="
                                      toggleDropdown(user.id);
                                      $event.stopPropagation()
                                    ">
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                            stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                            stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                            stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </button>
                      <div class="dropdown-wrapper" [class.show]="
                                      openedDropdownUserId === user.id
                                    ">
                        <ul class="dropdown-content">
                          <li>
                            @if (
                            isavailablefeature("isDeleteUser")
                            ) {
                            <a (click)="retrivedModal(user)" data-toggle="modal" data-target="#retrivedModal">
                              <img src="../../assets/team-management/edit-user.svg" />
                              <span>Re Active</span>
                            </a>
                            }
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
                }
                }
                }
              </tbody>
              }
            </table>
          </div>
          } @else {
          <div class="team-view-section">
            @if (employeeTab === "current") {
            @for (departmentName of departmentNames; track departmentName) {
            @if (filteredUsersList[departmentName] && filteredUsersList[departmentName].length > 0) {
            <h2 class="team-dept-header">{{ departmentName }}</h2>

            <div class="team-group-wrapper">
              <div class="team-management-table-wrapper">
                <!-- <table class="team-management-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Position</th>
                      <th class="fit-content-td">Shift Time</th>
                      @if (isavailablefeature("isWFH")) {
                      <th class="fit-content-td">Allow WFH</th>
                      }
                      @if (isavailablefeature("isDeleteUser") || isavailablefeature("isUpdateUser") ||
                      isavailablefeature("isMothySalary")) {
                      <th class="fit-content-td">Action</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (user of filteredUsersList[departmentName]; track user) {
                    <tr>
                      <td class="user-name-td" (click)="showUserDetails(user)">
                        <img src="{{ user.profile_image }}" alt="" />
                        <span class="text-elipse">{{ user.first_name }} {{ user.last_name }}</span>
                      </td>
                      <td>
                        <p class="text-elipse">{{ user.email }}</p>
                      </td>
                      <td>
                        <p class="text-elipse">{{ user.description }}</p>
                      </td>
                      <td class="fit-content-td">
                        {{ convertTo12Hour(user.usershittime && user.usershittime.length > 0 ?
                        user.usershittime[0].start_time : user.shift_start_time) }} to
                        {{ convertTo12Hour(user.usershittime && user.usershittime.length > 0 ?
                        user.usershittime[0].end_time : user.shift_end_time) }}
                      </td>
                      @if (isavailablefeature("isWFH")) {
                      <td class="fit-content-td text-center">
                        <label class="switch">
                          <input type="checkbox" #toggleRefT [checked]="isWFHAllowed(user)"
                            (change)="toggleClick(user, $event, toggleRefT)" />
                          <span class="slider round"></span>
                        </label>
                      </td>
                      }
                      <td class="fit-content-td text-center toogle-button">
                        <div class="dropdown-action">
                          <button class="dropdown-toggle-button"
                            (click)="toggleDropdown(user.id); $event.stopPropagation()">
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                                stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path
                                d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                                stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path
                                d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                                stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </button>
                          <div class="dropdown-wrapper" [class.show]="openedDropdownUserId === user.id">
                            <ul class="dropdown-content">
                              @if (isavailablefeature("isMothySalary")) {
                              <li><a (click)="showDetails(user)"><img src="../../assets/team-management/salary.svg" /><span>View Payroll</span></a></li>
                              }
                              @if(isavailablefeature("isReset")){
                              <li><a (click)="confirmReset2FA(user)"><i class="fa fa-refresh"></i><span>Reset 2FA</span></a></li>
                              }
                              @if(isavailablefeature("isAction")){
                              <li><a class="on-off"><span>Enable 2FA</span><label class="switch"><input type="checkbox" #toggleRef2FA_tl [checked]="user.auth_verify == 1" (change)="onTwoFactorClick(user, $event, toggleRef2FA_tl)" /><span class="slider-red round"></span></label></a></li>
                              }
                              @if (isavailablefeature("isUpdateUser")) {
                              <li><a data-toggle="modal" data-target="#quickEditModal" (click)="setUserUUID(user.uuid)"><img src="../../assets/team-management/edit-user.svg" /><span>Edit</span></a></li>
                              }
                              @if (isavailablefeature("isDeleteUser")) {
                              <li><a (click)="deleteModal(user)" data-toggle="modal" data-target="#deleteModal"><img src="../../assets/team-management/delete-user.svg" /><span>Delete</span></a></li>
                              }
                            </ul>
                          </div>
                        </div>
                      </td>
                    </tr>
                    }
                  </tbody>
                </table> -->

                <div class="team-view-listing">
                  @for (user of filteredUsersList[departmentName]; track user) {
                  <div class="team-card" >
                    <div class="team-user-detail-head">
                      <div class="team-user-left-head" (click)="showUserDetails(user)">
                        <div class="team-user-image">
                          <img src="{{ user.profile_image }}" alt="missing image">
                        </div>
                        <div class="team-user-heading">
                          <h1>{{ user.first_name }} {{ user.last_name }}</h1>
                          <span>{{ user.email }}</span>
                        </div>
                      </div>
                      <div class="team-user-right-head">
                          @if (isavailablefeature("isDeleteUser") || isavailablefeature("isUpdateUser") ||
                      isavailablefeature("isMothySalary")) {
                        <div class="dropdown-action">
                          <button class="dropdown-toggle-button"
                            (click)="toggleDropdown(user.id); $event.stopPropagation()">
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                                stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path
                                d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                                stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path
                                d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                                stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </button>
                          <div class="dropdown-wrapper team-view-option"
                            [class.show]="openedDropdownUserId === user.id">
                            <ul class="dropdown-content">
                              @if (isavailablefeature("isMothySalary")) {
                              <li><a (click)="showDetails(user)"><img
                                    src="../../assets/team-management/salary.svg" /><span>View Payroll</span></a></li>
                              }
                              @if(isavailablefeature("isReset")){
                              <li><a (click)="confirmReset2FA(user)"><i class="fa fa-refresh"></i><span>Reset
                                    2FA</span></a></li>
                              }
                              @if(isavailablefeature("isAction")){
                              <li><a class="on-off"><span>Enable 2FA</span><label class="switch"><input type="checkbox"
                                      #toggleRef2FA_tl [checked]="user.auth_verify == 1"
                                      (change)="onTwoFactorClick(user, $event, toggleRef2FA_tl)" /><span
                                      class="slider-red round"></span></label></a></li>
                              }
                              @if (isavailablefeature("isUpdateUser")) {
                              <li><a data-toggle="modal" data-target="#quickEditModal"
                                  (click)="setUserUUID(user.uuid)"><img
                                    src="../../assets/team-management/edit-user.svg" /><span>Edit</span></a></li>
                              }
                              @if (isavailablefeature("isDeleteUser")) {
                              <li><a (click)="deleteModal(user)" data-toggle="modal" data-target="#deleteModal"><img
                                    src="../../assets/team-management/delete-user.svg" /><span>Delete</span></a></li>
                              }
                            </ul>
                          </div>
                        </div>
                      }
                      </div>
                    </div>
                    <div class="team-user-detail-body">
                      <div class="team-user-detail-body-content">
                        <h1>Position</h1>
                        <span>{{ user.description }}</span>
                      </div>
                      <div class="team-user-detail-body-content">
                        <h1>Shift Time</h1>
                        <span> {{ convertTo12Hour(user.usershittime && user.usershittime.length > 0 ?
                          user.usershittime[0].start_time : user.shift_start_time) }} to
                          {{ convertTo12Hour(user.usershittime && user.usershittime.length > 0 ?
                          user.usershittime[0].end_time : user.shift_end_time) }}</span>
                      </div>
                      @if (isavailablefeature("isWFH")) {
                      <div class="team-user-detail-body-content">
                        <h1>WFH</h1>
                        <label class="switch">
                          <input type="checkbox" #toggleRefT [checked]="isWFHAllowed(user)"
                            (change)="toggleClick(user, $event, toggleRefT)" />
                          <span class="slider round"></span>
                        </label>
                      </div>
                      }
                    </div>
                  </div>

                  }

                </div>


              </div>
            </div>
            }
            }
            }
            @if (employeeTab === "ex") {
            @for (departmentName of departmentNames1; track departmentName) {
            @if (filteredOldUsersList[departmentName] && filteredOldUsersList[departmentName].length > 0) {
              <h2 class="team-dept-header">{{ departmentName }}</h2>
            <div class="team-group-wrapper">
              <div class="team-management-table-wrapper">
                <!-- <table class="team-management-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Position</th>
                      <th class="fit-content-td">Shift Time</th>
                      <th class="fit-content-td">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (user of filteredOldUsersList[departmentName]; track user) {
                    <tr>
                      <td class="user-name-td">
                        <img src="{{ user.profile_image }}" alt="" />
                        <span class="text-elipse">{{ user.first_name }} {{ user.last_name }}</span>
                      </td>
                      <td>
                        <p class="text-elipse">{{ user.email }}</p>
                      </td>
                      <td>
                        <p class="text-elipse">{{ user.description }}</p>
                      </td>
                      <td class="fit-content-td">
                        {{ convertTo12Hour(user.usershittime && user.usershittime.length > 0 ?
                        user.usershittime[0].start_time : user.shift_start_time) }} to
                        {{ convertTo12Hour(user.usershittime && user.usershittime.length > 0 ?
                        user.usershittime[0].end_time : user.shift_end_time) }}
                      </td>
                      <td class="fit-content-td text-center toogle-button">
                        <div class="dropdown-action">
                          <button class="dropdown-toggle-button"
                            (click)="toggleDropdown(user.id); $event.stopPropagation()">
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                                stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path
                                d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                                stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path
                                d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                                stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </button>
                          <div class="dropdown-wrapper" [class.show]="openedDropdownUserId === user.id">
                            <ul class="dropdown-content">
                              <li>
                                @if (isavailablefeature("isDeleteUser")) {
                                <a (click)="retrivedModal(user)" data-toggle="modal" data-target="#retrivedModal">
                                  <img src="../../assets/team-management/edit-user.svg" />
                                  <span>Re Active</span>
                                </a>
                                }
                              </li>
                            </ul>
                          </div>
                        </div>
                      </td>
                    </tr>
                    }
                  </tbody>
                </table> -->
              
                  <div class="team-view-listing">
                  @for (user of filteredOldUsersList[departmentName]; track user) {
                  <div class="team-card">
                    <div class="team-user-detail-head">
                      <div class="team-user-left-head">
                        <div class="team-user-image">
                          <img src="{{ user.profile_image }}" alt="missing image">
                        </div>
                        <div class="team-user-heading">
                          <h1>{{ user.first_name }} {{ user.last_name }}</h1>
                          <span>{{ user.email }}</span>
                        </div>
                      </div>
                      <div class="team-user-right-head">
                          @if (isavailablefeature("isDeleteUser")) {
                        <div class="dropdown-action">
                          <button class="dropdown-toggle-button"
                            (click)="toggleDropdown(user.id); $event.stopPropagation()">
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                                stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path
                                d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                                stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path
                                d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                                stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </button>
                          <div class="dropdown-wrapper team-view-option"
                            [class.show]="openedDropdownUserId === user.id">
                            <ul class="dropdown-content">
                              <li>
                                <a (click)="retrivedModal(user)" data-toggle="modal" data-target="#retrivedModal">
                                  <img src="../../assets/team-management/edit-user.svg" />
                                  <span>Re Active</span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      }
                      </div>
                    </div>
                    <div class="team-user-detail-body">
                      <div class="team-user-detail-body-content">
                        <h1>Position</h1>
                        <span>{{ user.description }}</span>
                      </div>
                      <div class="team-user-detail-body-content">
                        <h1>Shift Time</h1>
                        <span> {{ convertTo12Hour(user.usershittime && user.usershittime.length > 0 ?
                          user.usershittime[0].start_time : user.shift_start_time) }} to
                          {{ convertTo12Hour(user.usershittime && user.usershittime.length > 0 ?
                          user.usershittime[0].end_time : user.shift_end_time) }}</span>
                      </div>
                    </div>
                  </div>

                  }

                </div>
              
              </div>
            </div>
            }
            }
            }
          </div>
          }
        </div>
        }
        @if (activeTab === "user-cards") {
        <div>
          @if (!isTeamView) {
          @if (employeeTab === "current") {
          <div class="user-grid-section">
            @for (
            departmentName of departmentNames;
            track departmentName
            ) {
            @for (
            user of filteredUsersList[departmentName];
            track user;
            let i = $index
            ) {
            <div class="user-grid-card">
              <div class="image-wrapper">
                <img src="{{ user.profile_image }}" alt="" />
              </div>
              @if (hasCrown(user)) {
              <div class="crown-icon">
                <img src="../../assets/team-management/crown.png" alt="" />
              </div>
              }
              <div class="user-info">
                <h2>
                  {{ user.first_name }} {{ user.last_name
                  }}<span>{{ user.department }}</span>
                </h2>
                <div class="dropdown-action" (mouseleave)="closeDropdown()">
                  <button class="dropdown-toggle-button" (click)="
                                toggleDropdown(user.id);
                                $event.stopPropagation()
                              ">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </button>
                  <div class="dropdown-wrapper" [class.show]="openedDropdownUserId === user.id">
                    <ul class="dropdown-content">
                      <li>
                        @if (isavailablefeature("isWFH")) {
                        <a>
                          <span>Allow WFH</span>
                          <label class="switch">
                            <input type="checkbox" #toggleRef [checked]="isWFHAllowed(user)" (change)="
                                            toggleClick(user, $event, toggleRef)
                                          " />
                            <span class="slider round"></span>
                          </label>
                        </a>
                        }
                      </li>
                      <li>
                        @if (isavailablefeature("isUpdateUser")) {
                        <a (click)="showDetails(user)">
                          <img src="../../assets/team-management/salary.svg" />
                          <span>View Payroll</span>
                        </a>
                        }
                      </li>
                      <li>
                        <a (click)="confirmReset2FA(user)">
                          <i class="fa fa-refresh"></i>
                          <span>Reset 2FA</span>
                        </a>
                      </li>
                      <li>
                        <a class="on-off">
                          <span>Enable 2FA</span>
                          <label class="switch">
                            <input type="checkbox" #toggleRef2FA_grid [checked]="user.auth_verify == 1"
                              (change)="onTwoFactorClick(user, $event, toggleRef2FA_grid)" />
                            <span class="slider-red round"></span>
                          </label>
                        </a>
                      </li>
                      <li>
                        @if (isavailablefeature("isUpdateUser")) {
                        <a data-toggle="modal" data-target="#quickEditModal" (click)="setUserUUID(user.uuid)">
                          <img src="../../assets/team-management/edit-user.svg" alt="" />
                          <span>Edit</span>
                        </a>
                        }
                      </li>
                      <li>
                        @if (isavailablefeature("isDeleteUser")) {
                        <a (click)="deleteModal(user)" data-toggle="modal" data-target="#deleteModal">
                          <img src="../../assets/team-management/delete-user.svg" alt="" />
                          <span>Delete</span>
                        </a>
                        }
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            }
            }
          </div>
          }
          @if (employeeTab === "ex") {
          <div class="user-grid-section">
            @for (department of departmentNames1; track department) {
            @if (
            oldUsersList[department] &&
            oldUsersList[department].length > 0
            ) {
            @for (
            user of filteredOldUsersList[department];
            track user;
            let i = $index
            ) {
            <div class="user-grid-card">
              <div class="image-wrapper">
                <img src="{{ user.profile_image }}" alt="" />
              </div>
              <div class="crown-icon">
                <img src="../../assets/team-management/crown.png" alt="" />
              </div>
              <div class="user-info">
                <h2>
                  {{ user.first_name }} {{ user.last_name }}
                  <span>{{ user.department }}</span>
                </h2>
                <div class="dropdown-action" (mouseleave)="closeDropdown()">
                  <button class="dropdown-toggle-button" (click)="
                                  toggleDropdown(user.id);
                                  $event.stopPropagation()
                                ">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </button>
                  <div class="dropdown-wrapper" [class.show]="openedDropdownUserId === user.id">
                    <ul class="dropdown-content">
                      <li>
                        @if (isavailablefeature("isDeleteUser")) {
                        <a (click)="retrivedModal(user)" data-toggle="modal" data-target="#retrivedModal">
                          <img src="../../assets/team-management/edit-user.svg" alt="" />
                          <span>Re Active</span>
                        </a>
                        }
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            }
            }
            }
          </div>
          }
          } @else {
          <div class="team-view-section">
            @if (employeeTab === "current") {
            @for (departmentName of departmentNames; track departmentName) {
            @if (filteredUsersList[departmentName] && filteredUsersList[departmentName].length > 0) {
            <div class="team-group-wrapper">
              <h2 class="team-dept-header">{{ departmentName }}</h2>
              <div class="user-grid-section">
                @for (user of filteredUsersList[departmentName]; track user; let i = $index) {
                <div class="user-grid-card">
                  <div class="image-wrapper">
                    <img src="{{ user.profile_image }}" alt="" />
                  </div>
                  @if (hasCrown(user)) {
                  <div class="crown-icon">
                    <img src="../../assets/team-management/crown.png" alt="" />
                  </div>
                  }
                  <div class="user-info">
                    <h2>
                      {{ user.first_name }} {{ user.last_name }}
                      <span>{{ user.description }}</span>
                    </h2>
                    <div class="dropdown-action" (mouseleave)="closeDropdown()">
                      <button class="dropdown-toggle-button" (click)="
                                toggleDropdown(user.id);
                                $event.stopPropagation()
                              ">
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </button>
                      <div class="dropdown-wrapper" [class.show]="openedDropdownUserId === user.id">
                        <ul class="dropdown-content">
                          <li>
                            @if (isavailablefeature("isWFH")) {
                            <a>
                              <span>Allow WFH</span>
                              <label class="switch">
                                <input type="checkbox" #toggleRef [checked]="isWFHAllowed(user)" (change)="
                                                toggleClick(user, $event, toggleRef)
                                              " />
                                <span class="slider round"></span>
                              </label>
                            </a>
                            }
                          </li>
                          <li>
                            @if (isavailablefeature("isUpdateUser")) {
                            <a (click)="showDetails(user)">
                              <img src="../../assets/team-management/salary.svg" />
                              <span>View Payroll</span>
                            </a>
                            }
                          </li>
                          <li>
                            <a (click)="confirmReset2FA(user)">
                              <i class="fa fa-refresh"></i>
                              <span>Reset 2FA</span>
                            </a>
                          </li>
                          <li>
                            <a class="on-off">
                              <span>Enable 2FA</span>
                              <label class="switch">
                                <input type="checkbox" #toggleRef2FA_team [checked]="user.auth_verify == 1"
                                  (change)="onTwoFactorClick(user, $event, toggleRef2FA_team)" />
                                <span class="slider-red round"></span>
                              </label>
                            </a>
                          </li>
                          <li>
                            @if (isavailablefeature("isUpdateUser")) {
                            <a data-toggle="modal" data-target="#quickEditModal" (click)="setUserUUID(user.uuid)">
                              <img src="../../assets/team-management/edit-user.svg" alt="" />
                              <span>Edit</span>
                            </a>
                            }
                          </li>
                          <li>
                            @if (isavailablefeature("isDeleteUser")) {
                            <a (click)="deleteModal(user)" data-toggle="modal" data-target="#deleteModal">
                              <img src="../../assets/team-management/delete-user.svg" alt="" />
                              <span>Delete</span>
                            </a>
                            }
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
            }
            }
            }
            @if (employeeTab === "ex") {
            @for (departmentName of departmentNames1; track departmentName) {
            @if (filteredOldUsersList[departmentName] && filteredOldUsersList[departmentName].length > 0) {
            <div class="team-group-wrapper">
              <h2 class="team-dept-header">{{ departmentName }}</h2>
              <div class="user-grid-section">
                @for (user of filteredOldUsersList[departmentName]; track user; let i = $index) {
                <div class="user-grid-card">
                  <div class="image-wrapper">
                    <img src="{{ user.profile_image }}" alt="" />
                  </div>
                  <div class="crown-icon">
                    <img src="../../assets/team-management/crown.png" alt="" />
                  </div>
                  <div class="user-info">
                    <h2>
                      {{ user.first_name }} {{ user.last_name }}
                      <span>{{ user.description }}</span>
                    </h2>
                    <div class="dropdown-action" (mouseleave)="closeDropdown()">
                      <button class="dropdown-toggle-button" (click)="
                                    toggleDropdown(user.id);
                                    $event.stopPropagation()
                                  ">
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </button>
                      <div class="dropdown-wrapper" [class.show]="openedDropdownUserId === user.id">
                        <ul class="dropdown-content">
                          <li>
                            @if (isavailablefeature("isDeleteUser")) {
                            <a (click)="retrivedModal(user)" data-toggle="modal" data-target="#retrivedModal">
                              <img src="../../assets/team-management/edit-user.svg" alt="" />
                              <span>Re Active</span>
                            </a>
                            }
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
            }
            }
            }
          </div>
          }
        </div>
        }
        @if (activeTab === "team-view") {
        <div class="team-view-section">
          @if (employeeTab === "current") {
          @for (departmentName of departmentNames; track departmentName) {
          @if (filteredUsersList[departmentName] && filteredUsersList[departmentName].length > 0) {
          <div class="team-group-wrapper">
            <h2 class="team-dept-header">{{ departmentName }}</h2>
            <div class="user-grid-section">
              @for (user of filteredUsersList[departmentName]; track user; let i = $index) {
              <div class="user-grid-card">
                <div class="image-wrapper">
                  <img src="{{ user.profile_image }}" alt="" />
                </div>
                @if (hasCrown(user)) {
                <div class="crown-icon">
                  <img src="../../assets/team-management/crown.png" alt="" />
                </div>
                }
                <div class="user-info">
                  <h2>
                    {{ user.first_name }} {{ user.last_name }}
                    <span>{{ user.description }}</span>
                  </h2>
                  <div class="dropdown-action" (mouseleave)="closeDropdown()">
                    <button class="dropdown-toggle-button" (click)="
                                toggleDropdown(user.id);
                                $event.stopPropagation()
                              ">
                      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                          stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                          stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                          stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </button>
                    <div class="dropdown-wrapper" [class.show]="openedDropdownUserId === user.id">
                      <ul class="dropdown-content">
                        <li>
                          @if (isavailablefeature("isWFH")) {
                          <a>
                            <span>Allow WFH</span>
                            <label class="switch">
                              <input type="checkbox" #toggleRef [checked]="isWFHAllowed(user)" (change)="
                                              toggleClick(user, $event, toggleRef)
                                            " />
                              <span class="slider round"></span>
                            </label>
                          </a>
                          }
                        </li>
                        <li>
                          @if (isavailablefeature("isUpdateUser")) {
                          <a (click)="showDetails(user)">
                            <img src="../../assets/team-management/salary.svg" />
                            <span>View Payroll</span>
                          </a>
                          }
                        </li>
                        <li>
                          <a (click)="confirmReset2FA(user)">
                            <i class="fa fa-refresh"></i>
                            <span>Reset 2FA</span>
                          </a>
                        </li>
                        <li>
                          <a class="on-off">
                            <span>Enable 2FA</span>
                            <label class="switch">
                              <input type="checkbox" #toggleRef2FA_team [checked]="user.auth_verify == 1"
                                (change)="onTwoFactorClick(user, $event, toggleRef2FA_team)" />
                              <span class="slider-red round"></span>
                            </label>
                          </a>
                        </li>
                        <li>
                          @if (isavailablefeature("isUpdateUser")) {
                          <a data-toggle="modal" data-target="#quickEditModal" (click)="setUserUUID(user.uuid)">
                            <img src="../../assets/team-management/edit-user.svg" alt="" />
                            <span>Edit</span>
                          </a>
                          }
                        </li>
                        <li>
                          @if (isavailablefeature("isDeleteUser")) {
                          <a (click)="deleteModal(user)" data-toggle="modal" data-target="#deleteModal">
                            <img src="../../assets/team-management/delete-user.svg" alt="" />
                            <span>Delete</span>
                          </a>
                          }
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
          }
          }
          }
          @if (employeeTab === "ex") {
          @for (departmentName of departmentNames1; track departmentName) {
          @if (filteredOldUsersList[departmentName] && filteredOldUsersList[departmentName].length > 0) {
          <div class="team-group-wrapper">
            <h2 class="team-dept-header">{{ departmentName }}</h2>
            <div class="user-grid-section">
              @for (user of filteredOldUsersList[departmentName]; track user; let i = $index) {
              <div class="user-grid-card">
                <div class="image-wrapper">
                  <img src="{{ user.profile_image }}" alt="" />
                </div>
                <div class="crown-icon">
                  <img src="../../assets/team-management/crown.png" alt="" />
                </div>
                <div class="user-info">
                  <h2>
                    {{ user.first_name }} {{ user.last_name }}
                    <span>{{ user.description }}</span>
                  </h2>
                  <div class="dropdown-action" (mouseleave)="closeDropdown()">
                    <button class="dropdown-toggle-button" (click)="
                                  toggleDropdown(user.id);
                                  $event.stopPropagation()
                                ">
                      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                          stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                          stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                          stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </button>
                    <div class="dropdown-wrapper" [class.show]="openedDropdownUserId === user.id">
                      <ul class="dropdown-content">
                        <li>
                          @if (isavailablefeature("isDeleteUser")) {
                          <a (click)="retrivedModal(user)" data-toggle="modal" data-target="#retrivedModal">
                            <img src="../../assets/team-management/edit-user.svg" alt="" />
                            <span>Re Active</span>
                          </a>
                          }
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
          }
          }
          }
        </div>
        }
      </div>
    </div>
    <div class="footerTM">
      <div class="action-buttons">




        <div class="common-left-border-sec">
          <div class="left-tab-buttons">
            <button [class.active]="!isTeamView" (click)="isTeamView = false">

              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.0001 7.16C17.9401 7.15 17.8701 7.15 17.8101 7.16C16.4301 7.11 15.3301 5.98 15.3301 4.58C15.3301 3.15 16.4801 2 17.9101 2C19.3401 2 20.4901 3.16 20.4901 4.58C20.4801 5.98 19.3801 7.11 18.0001 7.16Z"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M16.9699 14.4402C18.3399 14.6702 19.8499 14.4302 20.9099 13.7202C22.3199 12.7802 22.3199 11.2402 20.9099 10.3002C19.8399 9.59016 18.3099 9.35016 16.9399 9.59016"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M5.96998 7.16C6.02998 7.15 6.09998 7.15 6.15998 7.16C7.53998 7.11 8.63998 5.98 8.63998 4.58C8.63998 3.15 7.48998 2 6.05998 2C4.62998 2 3.47998 3.16 3.47998 4.58C3.48998 5.98 4.58998 7.11 5.96998 7.16Z"
                  stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M6.99994 14.4402C5.62994 14.6702 4.11994 14.4302 3.05994 13.7202C1.64994 12.7802 1.64994 11.2402 3.05994 10.3002C4.12994 9.59016 5.65994 9.35016 7.02994 9.59016"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M12.0001 14.6307C11.9401 14.6207 11.8701 14.6207 11.8101 14.6307C10.4301 14.5807 9.33008 13.4507 9.33008 12.0507C9.33008 10.6207 10.4801 9.4707 11.9101 9.4707C13.3401 9.4707 14.4901 10.6307 14.4901 12.0507C14.4801 13.4507 13.3801 14.5907 12.0001 14.6307Z"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M9.09021 17.7813C7.68021 18.7213 7.68021 20.2613 9.09021 21.2013C10.6902 22.2713 13.3102 22.2713 14.9102 21.2013C16.3202 20.2613 16.3202 18.7213 14.9102 17.7813C13.3202 16.7213 10.6902 16.7213 9.09021 17.7813Z"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              All Users
            </button>

            <button [class.active]="isTeamView" (click)="isTeamView = true">

              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.16006 10.87C9.06006 10.86 8.94006 10.86 8.83006 10.87C6.45006 10.79 4.56006 8.84 4.56006 6.44C4.56006 3.99 6.54006 2 9.00006 2C11.4501 2 13.4401 3.99 13.4401 6.44C13.4301 8.84 11.5401 10.79 9.16006 10.87Z"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M16.4098 4C18.3498 4 19.9098 5.57 19.9098 7.5C19.9098 9.39 18.4098 10.93 16.5398 11C16.4598 10.99 16.3698 10.99 16.2798 11"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M4.16021 14.56C1.74021 16.18 1.74021 18.82 4.16021 20.43C6.91021 22.27 11.4202 22.27 14.1702 20.43C16.5902 18.81 16.5902 16.17 14.1702 14.56C11.4302 12.73 6.92021 12.73 4.16021 14.56Z"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M18.3398 20C19.0598 19.85 19.7398 19.56 20.2998 19.13C21.8598 17.96 21.8598 16.03 20.2998 14.86C19.7498 14.44 19.0798 14.16 18.3698 14"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              Team View
            </button>


          </div>
        </div>


        <div class="common-left-border-sec">
          <div class="left-tab-buttons">
            <button [class.active]="employeeTab === 'current'" (click)="employeeTab = 'current'">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.6673 12L12.0007 13.3333L14.6673 10.6667M8.00065 10H5.33398C4.09147 10 3.47022 10 2.98016 10.203C2.32675 10.4736 1.80762 10.9928 1.53697 11.6462C1.33398 12.1362 1.33398 12.7575 1.33398 14M10.334 2.19384C11.3113 2.58943 12.0007 3.54754 12.0007 4.66667C12.0007 5.78579 11.3113 6.7439 10.334 7.13949M9.00065 4.66667C9.00065 6.13943 7.80674 7.33333 6.33398 7.33333C4.86123 7.33333 3.66732 6.13943 3.66732 4.66667C3.66732 3.19391 4.86123 2 6.33398 2C7.80674 2 9.00065 3.19391 9.00065 4.66667Z"
                  stroke="#00989B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Live
            </button>
            <button [class.active]="employeeTab === 'ex'" (click)="switchToExEmployees()">
              <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.0007 9.66667L14.334 13M14.334 9.66667L11.0007 13M10.334 1.19384C11.3113 1.58943 12.0007 2.54754 12.0007 3.66667C12.0007 4.78579 11.3113 5.7439 10.334 6.13949M8.00065 9H5.33398C4.09147 9 3.47022 9 2.98016 9.20299C2.32675 9.47364 1.80762 9.99277 1.53697 10.6462C1.33398 11.1362 1.33398 11.7575 1.33398 13M9.00065 3.66667C9.00065 5.13943 7.80674 6.33333 6.33398 6.33333C4.86123 6.33333 3.66732 5.13943 3.66732 3.66667C3.66732 2.19391 4.86123 1 6.33398 1C7.80674 1 9.00065 2.19391 9.00065 3.66667Z"
                  stroke="#A3A3A3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Ex
            </button>


          </div>
        </div>
        <div class="common-left-border-sec">
          <div class="tab-buttons">
            <button [class.active]="activeTab === 'user-list'" (click)="setTab('user-list')">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z"
                  stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Listing
            </button>
            <button [class.active]="activeTab === 'user-cards'" (click)="setTab('user-cards')">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7 2.5H3.83333C3.36662 2.5 3.13327 2.5 2.95501 2.59083C2.79821 2.67072 2.67072 2.79821 2.59083 2.95501C2.5 3.13327 2.5 3.36662 2.5 3.83333V7C2.5 7.46671 2.5 7.70007 2.59083 7.87833C2.67072 8.03513 2.79821 8.16261 2.95501 8.24251C3.13327 8.33333 3.36662 8.33333 3.83333 8.33333H7C7.46671 8.33333 7.70007 8.33333 7.87833 8.24251C8.03513 8.16261 8.16261 8.03513 8.24251 7.87833C8.33333 7.70007 8.33333 7.46671 8.33333 7V3.83333C8.33333 3.36662 8.33333 3.13327 8.24251 2.95501C8.16261 2.79821 8.03513 2.67072 7.87833 2.59083C7.70007 2.5 7.46671 2.5 7 2.5Z"
                  stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M16.1667 2.5H13C12.5333 2.5 12.2999 2.5 12.1217 2.59083C11.9649 2.67072 11.8374 2.79821 11.7575 2.95501C11.6667 3.13327 11.6667 3.36662 11.6667 3.83333V7C11.6667 7.46671 11.6667 7.70007 11.7575 7.87833C11.8374 8.03513 11.9649 8.16261 12.1217 8.24251C12.2999 8.33333 12.5333 8.33333 13 8.33333H16.1667C16.6334 8.33333 16.8667 8.33333 17.045 8.24251C17.2018 8.16261 17.3293 8.03513 17.4092 7.87833C17.5 7.70007 17.5 7.46671 17.5 7V3.83333C17.5 3.36662 17.5 3.13327 17.4092 2.95501C17.3293 2.79821 17.2018 2.67072 17.045 2.59083C16.8667 2.5 16.6334 2.5 16.1667 2.5Z"
                  stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M16.1667 11.6667H13C12.5333 11.6667 12.2999 11.6667 12.1217 11.7575C11.9649 11.8374 11.8374 11.9649 11.7575 12.1217C11.6667 12.2999 11.6667 12.5333 11.6667 13V16.1667C11.6667 16.6334 11.6667 16.8667 11.7575 17.045C11.8374 17.2018 11.9649 17.3293 12.1217 17.4092C12.2999 17.5 12.5333 17.5 13 17.5H16.1667C16.6334 17.5 16.8667 17.5 17.045 17.4092C17.2018 17.3293 17.3293 17.2018 17.4092 17.045C17.5 16.8667 17.5 16.6334 17.5 16.1667V13C17.5 12.5333 17.5 12.2999 17.4092 12.1217C17.3293 11.9649 17.2018 11.8374 17.045 11.7575C16.8667 11.6667 16.6334 11.6667 16.1667 11.6667Z"
                  stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M7 11.6667H3.83333C3.36662 11.6667 3.13327 11.6667 2.95501 11.7575C2.79821 11.8374 2.67072 11.9649 2.59083 12.1217C2.5 12.2999 2.5 12.5333 2.5 13V16.1667C2.5 16.6334 2.5 16.8667 2.59083 17.045C2.67072 17.2018 2.79821 17.3293 2.95501 17.4092C3.13327 17.5 3.36662 17.5 3.83333 17.5H7C7.46671 17.5 7.70007 17.5 7.87833 17.4092C8.03513 17.3293 8.16261 17.2018 8.24251 17.045C8.33333 16.8667 8.33333 16.6334 8.33333 16.1667V13C8.33333 12.5333 8.33333 12.2999 8.24251 12.1217C8.16261 11.9649 8.03513 11.8374 7.87833 11.7575C7.70007 11.6667 7.46671 11.6667 7 11.6667Z"
                  stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Grid
            </button>
          </div>
        </div>
        @if (isavailablefeature("isAddUser")) {
        <div class="common-left-border-sec">
          <div class="adduser-icon-btn">
            @if (isavailablefeature("isAddUser")) {
            <button (click)="addNewUserBtn()">
              <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.0002 12.1111H6.00022C4.75972 12.1111 4.13947 12.1111 3.63476 12.2642C2.4984 12.6089 1.60914 13.4982 1.26443 14.6345C1.11133 15.1392 1.11133 15.7595 1.11133 17M16.2224 17V11.6667M13.5558 14.3333H18.8891M12.2224 5C12.2224 7.20914 10.4316 9 8.22244 9C6.0133 9 4.22244 7.20914 4.22244 5C4.22244 2.79086 6.0133 1 8.22244 1C10.4316 1 12.2224 2.79086 12.2224 5Z"
                  stroke="#00989B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
            }
          </div>
        </div>
        }
        <div class="common-left-border-sec" [ngClass]="{
              'border-none':
                !isavailablefeature('isMothySalary') &&
                !isavailablefeature('isloanReport'),
            }">
          <div class="adduser-icon-btn">
            <button>
              <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1.11133 2.42222C1.11133 1.9244 1.11133 1.67549 1.20821 1.48534C1.29343 1.31809 1.42941 1.1821 1.59667 1.09688C1.78681 1 2.03573 1 2.53355 1H17.4669C17.9647 1 18.2136 1 18.4038 1.09688C18.571 1.1821 18.707 1.31809 18.7922 1.48534C18.8891 1.67549 18.8891 1.9244 18.8891 2.42222V3.01724C18.8891 3.25617 18.8891 3.37563 18.8599 3.48672C18.834 3.58516 18.7914 3.67843 18.734 3.76245C18.6692 3.85727 18.5789 3.93551 18.3983 4.092L12.7132 9.01911C12.5326 9.1756 12.4424 9.25384 12.3775 9.34866C12.3201 9.43268 12.2775 9.52595 12.2516 9.62439C12.2224 9.73548 12.2224 9.85494 12.2224 10.0939V14.7408C12.2224 14.9146 12.2224 15.0015 12.1944 15.0767C12.1696 15.1431 12.1293 15.2026 12.0769 15.2502C12.0175 15.3042 11.9368 15.3365 11.7754 15.401L8.75321 16.6099C8.4265 16.7406 8.26315 16.8059 8.13201 16.7787C8.01734 16.7549 7.91671 16.6867 7.852 16.5891C7.77799 16.4775 7.77799 16.3015 7.77799 15.9497V10.0939C7.77799 9.85494 7.77799 9.73548 7.7488 9.62439C7.72293 9.52595 7.68034 9.43268 7.62289 9.34866C7.55806 9.25384 7.46779 9.1756 7.28723 9.01911L1.60209 4.092C1.42154 3.93551 1.33126 3.85727 1.26643 3.76245C1.20899 3.67843 1.1664 3.58516 1.14052 3.48672C1.11133 3.37563 1.11133 3.25617 1.11133 3.01724V2.42222Z"
                  stroke="#00989B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </div>
        @if (
        isavailablefeature("isMothySalary") ||
        isavailablefeature("isloanReport")
        ) {
        <div class="common-left-border-sec border-none">
          <div class="adduser-icon-btn filter-button">
            <button (click)="toggleDropdownanimation()" class="clsDropdownanimation">
              <svg width="16" height="4" viewBox="0 0 16 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00022 1.11089C7.5093 1.11089 7.11133 1.50886 7.11133 1.99978C7.11133 2.4907 7.5093 2.88867 8.00022 2.88867C8.49114 2.88867 8.88911 2.4907 8.88911 1.99978C8.88911 1.50886 8.49114 1.11089 8.00022 1.11089Z"
                  stroke="#00989B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M1.77799 1.11089C1.28707 1.11089 0.889105 1.50886 0.889105 1.99978C0.889105 2.4907 1.28707 2.88867 1.77799 2.88867C2.26891 2.88867 2.66688 2.4907 2.66688 1.99978C2.66688 1.50886 2.26891 1.11089 1.77799 1.11089Z"
                  stroke="#00989B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M14.2224 1.11089C13.7315 1.11089 13.3336 1.50886 13.3336 1.99978C13.3336 2.4907 13.7315 2.88867 14.2224 2.88867C14.7134 2.88867 15.1113 2.4907 15.1113 1.99978C15.1113 1.50886 14.7134 1.11089 14.2224 1.11089Z"
                  stroke="#00989B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
            @if (showDropdown) {
            <ul class="dropdown-menu-up">
              <!-- @if (isavailablefeature("isMothySalary")) {
              <li data-toggle="modal" data-target="#monthlySalary" data-dismiss="modal">
                <div class="upward-list-icon">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M4.33852 7.48544C4.33852 8.14306 4.87162 8.67617 5.52925 8.67617H6.63492C7.33952 8.67617 7.9107 8.10499 7.9107 7.40039C7.9107 6.6958 7.33952 6.12461 6.63492 6.12461H5.6143C4.9097 6.12461 4.33852 5.55342 4.33852 4.84883C4.33852 4.14423 4.9097 3.57305 5.6143 3.57305H6.71997C7.3776 3.57305 7.9107 4.10615 7.9107 4.76378M6.12461 2.80758V3.57305M6.12461 8.67617V9.44164M11.2277 6.12461C11.2277 8.94299 8.94299 11.2277 6.12461 11.2277C3.30623 11.2277 1.02148 8.94299 1.02148 6.12461C1.02148 3.30623 3.30623 1.02148 6.12461 1.02148C8.94299 1.02148 11.2277 3.30623 11.2277 6.12461Z"
                      stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                Salary Report
              </li>
              } -->
              <li data-toggle="modal" data-target="#shiftTime" data-dismiss="modal">
                <div class="upward-list-icon">
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M11 5V11L15 13M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
                      stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                Change Shift Time
              </li>
              @if (isavailablefeature("isloanReport")) {
              <li (click)="loanReport()">
                <div class="upward-list-icon">
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6.90513 4.26292C6.61301 4.47117 6.25554 4.59367 5.86945 4.59367C4.88302 4.59367 4.08336 3.79401 4.08336 2.80758C4.08336 1.82115 4.88302 1.02148 5.86945 1.02148C6.50887 1.02148 7.06981 1.35748 7.38534 1.86255M3.06273 10.2516H4.3948C4.56848 10.2516 4.74109 10.2723 4.90946 10.3136L6.31694 10.6556C6.62234 10.73 6.94049 10.7372 7.24907 10.6773L8.80527 10.3746C9.21636 10.2945 9.59452 10.0976 9.89089 9.80932L10.9919 8.73828C11.3063 8.43294 11.3063 7.93746 10.9919 7.6316C10.7088 7.35622 10.2606 7.32522 9.94028 7.55875L8.65709 8.49494C8.47332 8.62927 8.24971 8.7016 8.01973 8.7016H6.78062L7.56934 8.70157C8.01389 8.70157 8.37399 8.35127 8.37399 7.91883V7.76228C8.37399 7.4032 8.12277 7.0901 7.76479 7.0033L6.54745 6.70726C6.34934 6.65921 6.14645 6.63492 5.9425 6.63492C5.45015 6.63492 4.55892 7.04257 4.55892 7.04257L3.06273 7.66824M10.2071 3.31789C10.2071 4.30432 9.40745 5.10398 8.42102 5.10398C7.43458 5.10398 6.63492 4.30432 6.63492 3.31789C6.63492 2.33146 7.43458 1.5318 8.42102 1.5318C9.40745 1.5318 10.2071 2.33146 10.2071 3.31789ZM1.02148 7.45142L1.02148 10.4112C1.02148 10.697 1.02148 10.8399 1.07711 10.9491C1.12603 11.0451 1.2041 11.1232 1.30012 11.1721C1.40928 11.2277 1.55218 11.2277 1.83798 11.2277H2.24623C2.53204 11.2277 2.67494 11.2277 2.7841 11.1721C2.88012 11.1232 2.95819 11.0451 3.00711 10.9491C3.06273 10.8399 3.06273 10.697 3.06273 10.4112V7.45142C3.06273 7.16562 3.06273 7.02272 3.00711 6.91356C2.95819 6.81754 2.88012 6.73947 2.7841 6.69054C2.67494 6.63492 2.53204 6.63492 2.24623 6.63492L1.83798 6.63492C1.55218 6.63492 1.40928 6.63492 1.30012 6.69054C1.2041 6.73947 1.12603 6.81754 1.07711 6.91356C1.02148 7.02272 1.02148 7.16562 1.02148 7.45142Z"
                      stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                @if (loannotification.total_count != 0) {
                <span class="req-notify">
                  {{ loannotification.total_count }}
                </span>
                }
                Loan Report
              </li>
              }
            </ul>
            }
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  }
</div>

<!-- WFH modal -->

<div class="modal fade" id="confirmModalss" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content custom-modal" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="modal-header text-white" style="
          padding-right: 20px;
          display: flex;
          align-items: center;
          border-bottom: none;
        ">
        <!-- <button type="button" data-bs-dismiss="modal" class="close">×</button> -->
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          ×
        </button>
      </div>
      @if (toggleUserStatus == 1) {
      <div class="modal-body text-center" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
        <img src="../../../assets/images/trackerConfirm.png" class="imageConfirmModal" alt="img loading..." />
        <p class="modal-text mt-3">
          Are you sure you want to
          <span class="textColorQuestionMOdal">Allow
            <span class="textColorMOdal">{{ userNameForModal }}</span></span>
          to
          <span class="textColorMOdal">work from home</span>?
        </p>
        <div class="buttonTrackers gap-3 mt-3 mb-3">
          <button type="button" class="subBtnModalTrackerOff custom-btn" data-dismiss="modal"
            (click)="modalClick(false)">
            Confirm Without Tracker
          </button>
          <button type="button" class="subBtnModalTrackerOn custom-btn" data-dismiss="modal" (click)="modalClick(true)">
            Enable Tracker & Confirm
          </button>
        </div>
      </div>
      }
      @if (toggleUserStatus == 0) {
      <div class="modal-body text-center" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
        <img src="../../../assets/images/trackerQuestion.png" class="imageConfirmModal" alt="img loading..." />
        <p class="modal-text mt-3">
          Are you sure you want to
          <span class="textColorQuestionMOdal">Change </span>
          <span class="textColorMOdal">{{ userNameForModal }}</span> status to
          <span class="textColorMOdal">work from home</span>?
        </p>
        <div class="buttonTrackers gap-3 mt-3 mb-3">
          <button type="button" class="subBtnModalTrackerOff custom-btn" data-dismiss="modal">
            Cancel
          </button>
          <button type="button" class="subBtnModalTrackerOn custom-btn" data-dismiss="modal"
            (click)="modalClickChangeValues()">
            Confirm
          </button>
        </div>
      </div>
      }
    </div>
  </div>
</div>

<!-- 2FA confirmation modal -->
<div class="modal fade" id="confirmModal2FA" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content custom-modal" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="modal-header text-white" style="
          padding-right: 20px;
          display: flex;
          align-items: center;
          border-bottom: none;
        ">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cancel2FAToggle()">
          ×
        </button>
      </div>
      <div class="modal-body text-center" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
        <img src="../../../assets/images/trackerQuestion.png" class="imageConfirmModal" alt="img loading..." />
        <p class="modal-text mt-3">
          Are you sure you want to
          <span class="textColorQuestionMOdal">{{ intended2FAStatus ? "Enable" : "Disable" }}
          </span>
          2FA for <span class="textColorMOdal">{{ userNameForModal }}</span>?
        </p>
        <div class="buttonTrackers gap-3 mt-3 mb-3">
          <button type="button" class="subBtnModalTrackerOff custom-btn" data-dismiss="modal"
            (click)="cancel2FAToggle()">
            Cancel
          </button>
          <button type="button" class="subBtnModalTrackerOn custom-btn" data-dismiss="modal"
            (click)="confirm2FAToggle()">
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- reactive modal -->
<div class="modal fade" id="retrivedModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="modal-header" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
        <h5 class="modal-title" id="exampleModalLongTitle">Confirmation</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
        <p>Are you sure you want to <b>Active </b> this User again?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          Close
        </button>
        <input type="hidden" [(ngModel)]="user.uuid" />
        <button type="button" class="btn btn-primary" (click)="UserRetrived()">
          Active
        </button>
      </div>
    </div>
  </div>
</div>

<!-- delete modal -->
<div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="modal-header" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
        <h5 class="modal-title" id="exampleModalLongTitle">Confirmation</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
        <p>Are you sure you want to <b>Delete </b> this User?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          Close
        </button>
        <input type="hidden" [(ngModel)]="user.uuid" />
        <button type="button" class="btn btn-danger" (click)="UserDelete()">
          Delete
        </button>
      </div>
    </div>
  </div>
</div>

<!-- qick Edit Modal -->
<div class="modal fade" id="quickEditModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog model-main modal-dialog-centered" role="document">
    <div class="modal-content custom-edit-modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="custom-modal-header">
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
          ✖
        </button>
      </div>
      <div class="modal-header modal-buttons-header" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
        <img src="../../../assets/images/quick2.svg" />
        <h5 class="modal-title" id="exampleModalLabel">Quick actions</h5>
        <p class="custom-modal-para">
          You can quickly perform key actions and manage important information
          seamlessly.
        </p>
      </div>

      <div class="action-buttons-new">
        <!-- Top row with 3 buttons -->
        <div class="action-row top">
          <div data-toggle="modal" data-target="#updateStatus" data-dismiss="modal">
            <img class="image-action-row" src="../../../assets/images/check-circle-broken.svg" /><span
              class="txt-action-row"> Status</span>
          </div>
          <div data-toggle="modal" data-target="#updatePassword" data-dismiss="modal">
            <img class="image-action-row" src="../../../assets/images/eye.svg" /><span class="txt-action-row">
              Password</span>
          </div>
          <div data-toggle="modal" data-target="#updateAccountNo" data-dismiss="modal">
            <img class="image-action-row" src="../../../assets/images/bank.svg" /><span class="txt-action-row"> Bank
              account</span>
          </div>
        </div>

        <!-- Bottom row with 2 buttons -->
        <div class="action-row bottom">
          <div data-toggle="modal" data-target="#updateSalary" data-dismiss="modal">
            <img class="image-action-row" src="../../../assets/images/currency-dollar.svg" /><span
              class="txt-action-row"> Salary</span>
          </div>
          <div data-dismiss="modal" (click)="UserUpdate(selectedUserUUID)">
            <img class="image-action-row" src="../../../assets/images/edit-03.svg" /><span class="txt-action-row"> Edit
              user</span>
          </div>
        </div>
      </div>

      <!-- <div class="modal-body row">
                                                                    <div class="modal-btn mt-2 mb-2 col-6 text-center">
                                                                      <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#updateStatus"
                                                                        data-dismiss="modal">
                                                                      Status</button>
                                                                    </div>
                                                                    <div class="modal-btn mt-2 mb-2 col-6 text-center">
                                                                      <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#updatePassword"
                                                                        data-dismiss="modal">
                                                                      Password</button>
                                                                    </div>

                                                                    <div class="modal-btn mt-2 mb-2 col-6 text-center">
                                                                      <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#updateAccountNo"
                                                                        data-dismiss="modal">
                                                                      Bank Account</button>
                                                                    </div>
                                                                    <div class="modal-btn mt-2 mb-2 col-6 text-center">
                                                                      <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#updateSalary"
                                                                      data-dismiss="modal">User Salary</button>
                                                                    </div>
                                                                    <div class="modal-btn mt-2 mb-2 col-6 text-center">
                                                                      <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="UserUpdate(selectedUserUUID)">Edit
                                                                      User</button>
                                                                    </div>
                                                                  </div> -->

      <!-- <div class="modal-footer">
                                                                  <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                                                                </div> -->
    </div>
  </div>
</div>

<!-- status update -->
<div class="modal fade hidecolor" id="updateStatus" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog model-main modal-dialog-centered" role="document">
    <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <form #statusUpdate="ngForm" (ngSubmit)="updateStatus(statusUpdate)">
        <div class="modal-btn modal-header modal-buttons-header"
          [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
          <img src="../../../assets/images/quick2.png" />
          <h5 class="modal-title" id="updateStatusLabel">Edit User Status</h5>
        </div>
        <div class="modal-body d-flex flex-wrap justify-content-center">
          <div class="col-8 mt-2 mb-2 select-box" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
            <select id="employee_type" [ngModel]="apidata != null ? apidata.employee_type : null" name="employee_type"
              data-toggle="dropdown" class="dropdown-toggle checks-dropdown form-control pl-4 selectpicker" ngModel
              #employee_type="ngModel" required>
              <option value="null" disabled selected>
                Select Employee Status
              </option>
              @for (status of statuses; track status) {
              <option [value]="status">{{ status }}</option>
              }
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal">
            Close
          </button>
          <button type="submit" class="btn btn-success">Save changes</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- shifttime Model -->
<div class="modal fade hidecolor" id="updateSifhtTime" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog model-main modal-dialog-centered" role="document">
    <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <form #ShiftTimeUpdate="ngForm" (ngSubmit)="updateShiftTime(ShiftTimeUpdate)">
        <div class="modal-btn modal-header modal-buttons-header"
          [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
          <img src="../../../assets/images/quick2.png" />
          <h5 class="modal-title" id="updateSifhtTimeLabel">Edit Shift Time</h5>
        </div>
        <div class="modal-body d-flex flex-wrap justify-content-center">
          <div class="col-8 mt-2 mb-2 select-box">
            <input type="time" [ngModel]="apidata != null ? apidata.shift_start_time : null"
              onfocus="this.type = 'time'" onblur="this.type = this.value ? 'time' : 'text'" name="startTime"
              id="startTime" ngModel #startTime="ngModel" class="form-control date-type" required />
          </div>
          <div class="col-8">
            <input type="text" [ngModel]="apidata != null ? apidata.shift_end_time : null"
              placeholder="Enter Shift End Time" onfocus="this.type = 'time'"
              onblur="this.type = this.value ? 'time' : 'text'" name="endTime" id="endTime" ngModel #startTime="ngModel"
              class="form-control date-type" required />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal">
            Close
          </button>
          <button type="submit" class="btn btn-success">Save changes</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Account No update -->
<div class="modal fade hidecolor" id="updateAccountNo" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog model-main modal-dialog-centered" role="document">
    <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <form #accountUpdate="ngForm" (ngSubmit)="updateAccount(accountUpdate)">
        <div class="modal-btn modal-header modal-buttons-header"
          [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
          <img src="../../../assets/images/quick2.png" />
          <h5 class="modal-title" id="updateAccountNo">Edit Account No</h5>
        </div>
        <div class="modal-body d-flex flex-wrap justify-content-center">
          <div class="col-8 mt-2 mb-2 select-box">
            <input type="text" name="ac_number" [ngModel]="apidata != null ? apidata.ac_number : null"
              (input)="restrictInputToAccounts($event)" id="ac_number" placeholder="Meezan Bank Account#*"
              class="form-control no-spin-arrows" ngModel #ac_number="ngModel" required />
            @if (ac_number.touched && ac_number.invalid) {
            <div class="text-danger pl-3 mt-2">i.e. 0000-0000000000</div>
            }
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal">
            Close
          </button>
          <button type="submit" class="btn btn-success">Save changes</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Salary update -->
<div class="modal fade hidecolor" id="updateSalary" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog model-main modal-dialog-centered" role="document">
    <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <form #salaryUpdate="ngForm" (ngSubmit)="updateSalary(salaryUpdate)">
        <div class="modal-btn modal-header modal-buttons-header"
          [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
          <img src="../../../assets/images/quick2.png" />
          <h5 class="modal-title" id="updateSalarylabel">Edit User Salary</h5>
        </div>
        <div class="modal-body d-flex flex-wrap justify-content-center">
          <div class="col-8 mt-2 mb-2 select-box" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
            <input type="text" name="salary" [ngModel]="apidata != null ? apidata.basic_salary : null" id="salary"
              placeholder="Monthly Salary*" class="form-control pl-4" ngModel #salary="ngModel" readonly />
          </div>
          <div class="col-8 mt-2 mb-2 select-box">
            <input type="text" name="newSalary" id="newSalary" placeholder="Enter New Salary Here*"
              class="form-control pl-4" ngModel #salary="ngModel" />
          </div>
          <div class="col-8 mt-2 mb-2 select-box">
            <input type="text" name="salaryTax" id="salaryTax" placeholder="Enter Salary Tax Here*"
              class="form-control pl-4" ngModel #salaryTax="ngModel" />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal">
            Close
          </button>
          <button type="submit" class="btn btn-success">Save changes</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- password Model -->
<div class="modal fade hidecolor" id="updatePassword" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog model-main modal-dialog-centered" role="document">
    <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <form #passwordUpdate="ngForm" (ngSubmit)="updatePassword(passwordUpdate)">
        <div class="modal-btn modal-header modal-buttons-header"
          [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
          <img src="../../../assets/images/quick2.png" />
          <h5 class="modal-title" id="updatePasswordLabel">
            Edit User Password
          </h5>
        </div>

        <div class="modal-body d-flex flex-wrap justify-content-center">
          <div class="col-8 mt-2 mb-2 select-box">
            <input type="text" inputmode="none" name="password" id="password" placeholder="Enter New Password"
              class="form-control" ngModel required />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal">
            Close
          </button>
          <button type="submit" class="btn btn-success">Save changes</button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="monthlySalary" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="modal-header" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Must Select Month To See Salary Report
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
        <div class="row button-row ml-1 mr-1 justify-content-between text-left"
          [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          <div class="col-sm-12 p-0 mb-4">
            @if (isavailablefeature("isMothySalary")) {
            <div class="d-flex justify-content-between">
              <div class="col-12 mt-3 mt-sm-0">
                <input type="text" onfocus="this.type = 'date'" placeholder="Select Month" name="salary_month"
                  id="salary_month" class="date-type form-control inputbtn pl-2" [(ngModel)]="selectedDate"
                  #enddate="ngModel" required />
                @if (
                showError && (!selectedDate || selectedDate.length === 0)
                ) {
                <div class="text-danger mt-1">Please select a month</div>
                }
              </div>
            </div>
            }
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            Close
          </button>
          <button (click)="monthlySalary()" type="submit" class="btn btn-primary apply show-salary">
            Show Salary
          </button>
        </div>
      </div>
    </div>
  </div>
</div>





<div class="modal fade" id="shiftTime" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog model-main-new modal-dialog-centered" role="document">
    <div class="modal-content custom-edit-modal-content shifttime-modal-content"
      [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="custom-modal-header new-shifttime-modal-head">
        <div class="header">
          <h3>Shift Details</h3>
          <button class="copy-btn" (click)="copyAll()">
            <img src="../../../assets/theme1/copy.png" alt="Missing Icon" />
          </button>
        </div>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
          ✖
        </button>
      </div>

      <div class="action-buttons-new">
        <div class="shift-container">
          <table class="shift-table">
            <thead>
              <tr>
                <th>Days</th>
                <th>Shift Start</th>
                <th>Shift End</th>
                <th>Working Hrs</th>
                <th>WFH</th>
                <th>Off Day</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let shift of shiftData; let i = index">
                <td class="day">{{ shift.day }}</td>

                <!-- Start Time -->
                <td>
                  <input type="time" [(ngModel)]="shift.start" [disabled]="shift.off" (change)="updateHours(i)"
                    [ngModelOptions]="{standalone: true}">
                </td>

                <!-- End Time -->
                <td>
                  <input type="time" [(ngModel)]="shift.end" [disabled]="shift.off" (change)="updateHours(i)"
                    [ngModelOptions]="{standalone: true}">
                </td>

                <!-- Hours -->
                <td>{{ shift.hours | number:'1.2-2' }}</td>

                <!-- WFH Toggle -->
                <td>
                  <label class="switch">
                    <input type="checkbox" [(ngModel)]="shift.wfh" [disabled]="shift.off">
                    <span class="slider"></span>
                  </label>
                  <span>{{ shift.wfh ? 'Yes' : 'No' }}</span>
                </td>

                <!-- Off Day Toggle -->
                <td>
                  <label class="switch">
                    <input type="checkbox" [(ngModel)]="shift.off">
                    <span class="slider"></span>
                  </label>
                  <span>{{ shift.off ? 'Yes' : 'No' }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="shift-modal-footer">
            <button class="save-btn" (click)="saveShift()">
              Save Shift
            </button>
          </div>

        </div>
      </div>

    </div>
  </div>
</div>